import styled, { css, DefaultTheme } from 'styled-components';
import { space } from 'styled-system';

import { CheckboxProps, Variant } from './Checkbox.types';
import { ThemeType } from 'src/packages/theme';

export const getCheckboxSize = (variant: Variant) => {
  if (variant === 'secondary') {
    return css`
      width: 17px;
      height: 16px;
    `;
  }

  return css`
    width: 21px;
    height: 20px;
  `;
};

export const getCheckMarkStyles = (variant: Variant) => {
  if (variant === 'secondary') {
    return css`
      width: 5px;
      height: 8px;
      top: 2px;
      left: 4px;
    `;
  }

  return css`
    width: 6px;
    height: 10px;
    top: 3px;
    left: 6px;
  `;
};

export const getIndeterminatekMarkStyles = (variant: Variant) => {
  if (variant === 'secondary') {
    return css`
      width: 7px;
      height: 0;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    `;
  }

  return css`
    width: 9px;
    height: 0;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  `;
};

export const Container = styled.div<Partial<CheckboxProps>>`
  display: flex;
  flex-direction: column;
  gap: 4px;
  ${space}
`;

export const CheckboxWrapper = styled.div<{
  checkboxSize: any;
  checkmarkStyles: any;
  indeterminateMarkStyles: any;
  defaulttheme: DefaultTheme;
  themevariant: ThemeType | undefined;
}>`
  display: flex;
  direction: ltr;
  gap: 8px;

  input[type='checkbox'] {
    position: absolute;
    opacity: 0;
    z-index: -1;
    margin: 0 !important;
    ${(props) => props.checkboxSize};
  }

  span.checkbox {
    margin-top: 3px;
    cursor: pointer;
    ${(props) => props.checkboxSize};
    display: flex;
    position: relative;
    border-width: 1px;
    border-style: solid;
    border-color: ${({ defaulttheme }) => defaulttheme.colors.border.middle};
    border-radius: 4px;

    &:hover,
    &:active {
      border-color: ${({ defaulttheme }) => defaulttheme.colors.palette.primary};
    }
  }

  [type='checkbox']:checked + span.checkbox {
    border-color: ${({ defaulttheme }) => defaulttheme.colors.palette.primary};
    background-color: ${({ defaulttheme }) => defaulttheme.colors.palette.primary};

    &:before {
      content: '';
      border-style: solid;
      border-color: ${({ defaulttheme }) => defaulttheme.colors.palette.black};
      border-width: 0 2px 2px 0;
      position: absolute;
      transform: ${(props) => (props.theme.rtl ? 'rotate(45deg) scaleX(-1)' : 'rotate(45deg)')};
      ${(props) => props.checkmarkStyles};
    }
  }

  [type='checkbox']:indeterminate + span.checkbox {
    border-color: ${({ defaulttheme }) => defaulttheme.colors.palette.primary};
    background-color: ${({ defaulttheme }) => defaulttheme.colors.palette.primary};

    &:before {
      content: '';
      border-style: solid;
      border-color: ${({ defaulttheme }) => defaulttheme.colors.palette.black};
      border-width: 2px 0 0 0;
      position: absolute;
      ${(props) => props.indeterminateMarkStyles};
    }
  }

  [type='checkbox']:disabled + span.checkbox {
    cursor: not-allowed;
    border-color: ${({ defaulttheme }) => defaulttheme.colors.border.middle} !important;
    background-color: ${({ defaulttheme }) =>
      defaulttheme.colors.background.secondary.BG4} !important;

    &:before {
      border-color: ${({ defaulttheme }) => defaulttheme.colors.text.disabled};
    }
  }
`;
